import React, { useEffect, useState } from 'react'
import sanityClient from '../Client'
import { Link } from 'react-router-dom'
import './BlogCollection.css'
import Hero from '../Components/Hero'
import { Helmet } from 'react-helmet'

function BlogCollection() {

    const [Posts, setPosts] = useState(null)

    useEffect(() => {
        sanityClient.fetch(`*[_type == "post"]{
            _id,
            title,
            slug,
            body,
            description,
            publishedAt,
            "categories": categories[]->{title,_id},
            mainImage {
              asset->{
                _id,
                url
              },
              alt
            },
            author->{
              name,
              image {
                asset->{
                  url
                }
              }
            }
                    }`)
            .then((data) => { setPosts(data); console.log(data) })
            .catch(error => console.error(error))

    }, [])

    return (
        <>
            <main className='min-h-[calc(100vh-80px)] bg-[#161623]' itemScope itemType='https://schema.org/Blog'>
                <Helmet>
                    <title>Blogs | Blogcode</title>
                    <meta name="description" content="Blogs by BlogCode" />
                    <meta name="keywords" content="react, blog, SEO, tips, blogging, reactjs" />
                    <meta name="author" content="Nimish Bandha" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <link rel="canonical" href="https://getblogcode.netlify.app/blogs" />
                </Helmet>
                {/* Your Company's Header */}
                <Hero />
                <section className='container mx-auto flex w-full justify-center gap-5 pb-5 flex-wrap'>
                    {Posts && Posts.map((post, index) => (
                        <article className='h-[400px] w-[300px] border-gray-500 border rounded-xl card' key={post._id} >

                            <Link to={"/blogs/" + post.slug.current} key={post.slug.current} className='flex flex-col gap-2 h-full '>

                                {/* YOU MAY CHANGE THE HEIGHT OF IMAGE */}
                                <img src={post?.mainImage?.asset?.url} alt={post?.mainImage?.alt ? post?.mainImage?.alt : 'Image alt'} className=' rounded-t-xl object-cover h-[140px] w-full' itemProp='image' />

                                <div className='flex flex-col gap-2 px-2 h-full'>
                                    <div className='flex gap-2'>
                                        {post?.categories && post.categories.map((tag, index) => (

                                            <Link to={`/blogs/tags/${tag.title}`} className='bg-[#D72638] text-white py-1 px-3 rounded-xl w-min transition hover:bg-transparent hover:text-[#D72638] hover:border-[#D72638] border' key={index}>{tag.title}</Link>
                                        ))}
                                    </div>

                                    <h1 className='text-3xl font-extrabold line-clamp-2 text-gray-100' title={post.title} itemProp='headline'>{post.title}</h1>

                                    <p className='text-gray-400 text-lg line-clamp-3' title={post.description} itemProp='description'>
                                        {post.description}
                                    </p>
                                </div>

                                <div className='flex items-center gap-4 p-2 rounded-b-xl'>
                                    <img src={post.author?.image?.asset.url} alt="author" className='h-12 rounded-full' />
                                    <span itemProp='author' className='text-gray-200'>{post.author.name}</span>
                                    <span className='text-gray-200'>{new Date(post.publishedAt).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                                </div>
                            </Link>

                        </article>
                    ))}
                </section>
            </main>
        </>
    )
}

export default BlogCollection